// Copyright (c) 2025 Audere, All Rights Reserved

import { CircularProgress, Backdrop } from "@mui/material";

import { useIsFetching } from "../features/api/apiSlice";
import { createStyleSheet } from "../utils/styles";

const AppLoader = () => {
  const isFetching = useIsFetching();

  return (
    <Backdrop sx={styles.backdrop} open={isFetching} data-testid="app-loader">
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default AppLoader;

const styles = createStyleSheet({
  backdrop: {
    color: "white",
    zIndex: theme => theme.zIndex.drawer + 1,
  },
});
